export default "__VITE_ASSET__D_29BOJU__"